import { createCollectionActions } from 'next/lib/collections';

export const TYPE = 'themes';

export const { patterns, read, reject, resolve } =
  createCollectionActions(TYPE);
